/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ProjectPlanData,
  UpdateDeliverablesRequest,
  UpdateOrgBriefRequest,
  UpdateProBriefRequest,
  UpdateProjectPlanRequest,
  UpdateSkillAlignmentsRequest,
  UpdateTasksRequest,
} from './platformapi.schemas';

import getProjectPlanByIdMutator from '../custom-axios-instance';
import updateProjectPlanDeliverablesMutator from '../custom-axios-instance';
import updateOrganizationBriefMutator from '../custom-axios-instance';
import updateProjectPlanMutator from '../custom-axios-instance';
import updateProBriefMutator from '../custom-axios-instance';
import updateSkillAlignmentMutator from '../custom-axios-instance';
import updateProjectPlanTasksMutator from '../custom-axios-instance';

/**
 * @summary Get Project Plan By Id
 */
export const getProjectPlanById = (planId: number, signal?: AbortSignal) => {
  return getProjectPlanByIdMutator<ProjectPlanData>({
    url: `${import.meta.env['VITE_API_HOST']}/project-plan/${planId}`,
    method: 'GET',
    signal,
  });
};

export const getGetProjectPlanByIdQueryKey = (planId?: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/project-plan/${planId}`] as const;
};

export const getGetProjectPlanByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectPlanById>>,
  TError = HTTPValidationError,
>(
  planId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPlanById>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectPlanByIdQueryKey(planId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectPlanById>>> = ({ signal }) =>
    getProjectPlanById(planId, signal);

  return { queryKey, queryFn, enabled: !!planId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectPlanById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectPlanByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectPlanById>>
>;
export type GetProjectPlanByIdQueryError = HTTPValidationError;

export function useGetProjectPlanById<
  TData = Awaited<ReturnType<typeof getProjectPlanById>>,
  TError = HTTPValidationError,
>(
  planId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPlanById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectPlanById>>,
          TError,
          Awaited<ReturnType<typeof getProjectPlanById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectPlanById<
  TData = Awaited<ReturnType<typeof getProjectPlanById>>,
  TError = HTTPValidationError,
>(
  planId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectPlanById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectPlanById>>,
          TError,
          Awaited<ReturnType<typeof getProjectPlanById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectPlanById<
  TData = Awaited<ReturnType<typeof getProjectPlanById>>,
  TError = HTTPValidationError,
>(
  planId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPlanById>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Project Plan By Id
 */

export function useGetProjectPlanById<
  TData = Awaited<ReturnType<typeof getProjectPlanById>>,
  TError = HTTPValidationError,
>(
  planId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectPlanById>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectPlanByIdQueryOptions(planId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Project Plan Deliverables
 */
export const updateProjectPlanDeliverables = (
  planId: number,
  updateDeliverablesRequest: UpdateDeliverablesRequest,
  signal?: AbortSignal,
) => {
  return updateProjectPlanDeliverablesMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/project-plan/${planId}/update-deliverables`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateDeliverablesRequest,
    signal,
  });
};

export const getUpdateProjectPlanDeliverablesMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProjectPlanDeliverables>>,
    TError,
    { planId: number; data: UpdateDeliverablesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProjectPlanDeliverables>>,
  TError,
  { planId: number; data: UpdateDeliverablesRequest },
  TContext
> => {
  const mutationKey = ['updateProjectPlanDeliverables'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProjectPlanDeliverables>>,
    { planId: number; data: UpdateDeliverablesRequest }
  > = (props) => {
    const { planId, data } = props ?? {};

    return updateProjectPlanDeliverables(planId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProjectPlanDeliverablesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProjectPlanDeliverables>>
>;
export type UpdateProjectPlanDeliverablesMutationBody = UpdateDeliverablesRequest;
export type UpdateProjectPlanDeliverablesMutationError = HTTPValidationError;

/**
 * @summary Update Project Plan Deliverables
 */
export const useUpdateProjectPlanDeliverables = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateProjectPlanDeliverables>>,
      TError,
      { planId: number; data: UpdateDeliverablesRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateProjectPlanDeliverables>>,
  TError,
  { planId: number; data: UpdateDeliverablesRequest },
  TContext
> => {
  const mutationOptions = getUpdateProjectPlanDeliverablesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Organization Brief
 */
export const updateOrganizationBrief = (
  planId: number,
  updateOrgBriefRequest: UpdateOrgBriefRequest,
  signal?: AbortSignal,
) => {
  return updateOrganizationBriefMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/project-plan/${planId}/update-organization-brief`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateOrgBriefRequest,
    signal,
  });
};

export const getUpdateOrganizationBriefMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganizationBrief>>,
    TError,
    { planId: number; data: UpdateOrgBriefRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrganizationBrief>>,
  TError,
  { planId: number; data: UpdateOrgBriefRequest },
  TContext
> => {
  const mutationKey = ['updateOrganizationBrief'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrganizationBrief>>,
    { planId: number; data: UpdateOrgBriefRequest }
  > = (props) => {
    const { planId, data } = props ?? {};

    return updateOrganizationBrief(planId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationBriefMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrganizationBrief>>
>;
export type UpdateOrganizationBriefMutationBody = UpdateOrgBriefRequest;
export type UpdateOrganizationBriefMutationError = HTTPValidationError;

/**
 * @summary Update Organization Brief
 */
export const useUpdateOrganizationBrief = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOrganizationBrief>>,
      TError,
      { planId: number; data: UpdateOrgBriefRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateOrganizationBrief>>,
  TError,
  { planId: number; data: UpdateOrgBriefRequest },
  TContext
> => {
  const mutationOptions = getUpdateOrganizationBriefMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Project Plan
 */
export const updateProjectPlan = (
  planId: number,
  updateProjectPlanRequest: UpdateProjectPlanRequest,
  signal?: AbortSignal,
) => {
  return updateProjectPlanMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/project-plan/${planId}/update-plan`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateProjectPlanRequest,
    signal,
  });
};

export const getUpdateProjectPlanMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProjectPlan>>,
    TError,
    { planId: number; data: UpdateProjectPlanRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProjectPlan>>,
  TError,
  { planId: number; data: UpdateProjectPlanRequest },
  TContext
> => {
  const mutationKey = ['updateProjectPlan'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProjectPlan>>,
    { planId: number; data: UpdateProjectPlanRequest }
  > = (props) => {
    const { planId, data } = props ?? {};

    return updateProjectPlan(planId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProjectPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProjectPlan>>
>;
export type UpdateProjectPlanMutationBody = UpdateProjectPlanRequest;
export type UpdateProjectPlanMutationError = HTTPValidationError;

/**
 * @summary Update Project Plan
 */
export const useUpdateProjectPlan = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateProjectPlan>>,
      TError,
      { planId: number; data: UpdateProjectPlanRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateProjectPlan>>,
  TError,
  { planId: number; data: UpdateProjectPlanRequest },
  TContext
> => {
  const mutationOptions = getUpdateProjectPlanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Pro Brief
 */
export const updateProBrief = (
  planId: number,
  updateProBriefRequest: UpdateProBriefRequest,
  signal?: AbortSignal,
) => {
  return updateProBriefMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/project-plan/${planId}/update-pro-brief`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateProBriefRequest,
    signal,
  });
};

export const getUpdateProBriefMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProBrief>>,
    TError,
    { planId: number; data: UpdateProBriefRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProBrief>>,
  TError,
  { planId: number; data: UpdateProBriefRequest },
  TContext
> => {
  const mutationKey = ['updateProBrief'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProBrief>>,
    { planId: number; data: UpdateProBriefRequest }
  > = (props) => {
    const { planId, data } = props ?? {};

    return updateProBrief(planId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProBriefMutationResult = NonNullable<Awaited<ReturnType<typeof updateProBrief>>>;
export type UpdateProBriefMutationBody = UpdateProBriefRequest;
export type UpdateProBriefMutationError = HTTPValidationError;

/**
 * @summary Update Pro Brief
 */
export const useUpdateProBrief = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateProBrief>>,
      TError,
      { planId: number; data: UpdateProBriefRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateProBrief>>,
  TError,
  { planId: number; data: UpdateProBriefRequest },
  TContext
> => {
  const mutationOptions = getUpdateProBriefMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Skill Alignment
 */
export const updateSkillAlignment = (
  planId: number,
  updateSkillAlignmentsRequest: UpdateSkillAlignmentsRequest,
  signal?: AbortSignal,
) => {
  return updateSkillAlignmentMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/project-plan/${planId}/update-skill-alignment`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateSkillAlignmentsRequest,
    signal,
  });
};

export const getUpdateSkillAlignmentMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSkillAlignment>>,
    TError,
    { planId: number; data: UpdateSkillAlignmentsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSkillAlignment>>,
  TError,
  { planId: number; data: UpdateSkillAlignmentsRequest },
  TContext
> => {
  const mutationKey = ['updateSkillAlignment'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSkillAlignment>>,
    { planId: number; data: UpdateSkillAlignmentsRequest }
  > = (props) => {
    const { planId, data } = props ?? {};

    return updateSkillAlignment(planId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSkillAlignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSkillAlignment>>
>;
export type UpdateSkillAlignmentMutationBody = UpdateSkillAlignmentsRequest;
export type UpdateSkillAlignmentMutationError = HTTPValidationError;

/**
 * @summary Update Skill Alignment
 */
export const useUpdateSkillAlignment = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSkillAlignment>>,
      TError,
      { planId: number; data: UpdateSkillAlignmentsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateSkillAlignment>>,
  TError,
  { planId: number; data: UpdateSkillAlignmentsRequest },
  TContext
> => {
  const mutationOptions = getUpdateSkillAlignmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Project Plan Tasks
 */
export const updateProjectPlanTasks = (
  planId: number,
  updateTasksRequest: UpdateTasksRequest,
  signal?: AbortSignal,
) => {
  return updateProjectPlanTasksMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/project-plan/${planId}/update-tasks`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateTasksRequest,
    signal,
  });
};

export const getUpdateProjectPlanTasksMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProjectPlanTasks>>,
    TError,
    { planId: number; data: UpdateTasksRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProjectPlanTasks>>,
  TError,
  { planId: number; data: UpdateTasksRequest },
  TContext
> => {
  const mutationKey = ['updateProjectPlanTasks'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProjectPlanTasks>>,
    { planId: number; data: UpdateTasksRequest }
  > = (props) => {
    const { planId, data } = props ?? {};

    return updateProjectPlanTasks(planId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProjectPlanTasksMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProjectPlanTasks>>
>;
export type UpdateProjectPlanTasksMutationBody = UpdateTasksRequest;
export type UpdateProjectPlanTasksMutationError = HTTPValidationError;

/**
 * @summary Update Project Plan Tasks
 */
export const useUpdateProjectPlanTasks = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateProjectPlanTasks>>,
      TError,
      { planId: number; data: UpdateTasksRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateProjectPlanTasks>>,
  TError,
  { planId: number; data: UpdateTasksRequest },
  TContext
> => {
  const mutationOptions = getUpdateProjectPlanTasksMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
